module.exports = __webpack_public_path__ + "img/contact_8.5b939fcb.png";